"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Slide_vue_1 = tslib_1.__importDefault(require("./Slide.vue"));
const RememberDevice_vue_1 = tslib_1.__importDefault(require("./RememberDevice.vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
const SlideHeader_vue_1 = tslib_1.__importDefault(require("./SlideHeader.vue"));
exports.default = vue_1.default.extend({
    name: 'code-stepup',
    props: {
        stepUpCategory: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedDestinationId: null,
            navigatingBack: false,
            header: '',
            subtitle: '',
            isSubmitting: false,
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        destinations() {
            return this.stepUpCategory.StepUpModel.Destinations;
        },
        selectedDestination: {
            get() {
                const id = this.selectedDestinationId;
                return this.destinations.find((destination) => destination.$id === id) || this.destinations[0];
            },
            set(destination) {
                this.selectedDestinationId = destination.$id;
            },
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        hasServerError() {
            return this.$store.state.errors.length > 0;
        },
        ariaDescriptionId() {
            return `destinationDescription${this.stepUpCategory.StepUpModel.AuthenticationFactorValue}`;
        },
    },
    methods: {
        async sendCode() {
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            await this.$store
                .dispatch('submitChallenge', {
                ...this.stepUpCategory.NextChallenge,
                Destination: { ...this.selectedDestination },
            });
            this.isSubmitting = false;
        },
        async navigateBack() {
            if (this.navigatingBack) {
                return;
            }
            this.navigatingBack = true;
            this.selectedDestinationId = null;
            await this.$store.dispatch('goToPreviousChallenge');
            this.navigatingBack = false;
        },
        changeDestinationSelection(newDestinationId) {
            this.selectedDestinationId = newDestinationId;
        },
    },
    mounted() {
        if (this.destinations.length > 0) {
            this.selectedDestination = this.destinations[0];
        }
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        RememberDevice: RememberDevice_vue_1.default,
        SlideHeader: SlideHeader_vue_1.default,
    },
});
